import PropTypes from 'prop-types'
import Link from 'next/link'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Error from '@components/error'
import Breadcrumbs from '@components/breadcrumbs'
import { StatesQuery } from '@components/states'
import SearchCourse from '@components/search-course'
import states from '@config/states'
import { CoursesInStateQuery } from '@components/courses-in-state'
import { NextSeo } from 'next-seo'
import defaults from '@config/defaults'
import { JsonLd } from '@components/atoms'
import CtaCard from '@layouts/things-to-do/cta-card'
import CtaBanner from '@layouts/things-to-do/cta-banner'

const CtaUrl = 'https://images.ctfassets.net/56u5qdsjym8c/77ir7RCkN7Ug7Wj0hbPvae/d3df775281f93bb363102aef4a849e57/Ladies-301.png'

const GolfCoursesPage = (props) => {
  const {
    query,
    ssrCitiesData,
    ssrStatesData,
  } = props
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))

  const stateName = states[query.state.toUpperCase()]

  const metaTitle = `Golf Courses in ${stateName} - PGA of America`
  const metaDescription = `Search public and private golf courses in ${stateName} to play golf. Find the nearest golf facilities to you.`
  const stateURL = `${defaults.baseUrl}play/${query.state}`.toLowerCase()
  return stateName ? (
    <div>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaTitle}
        description={metaDescription}
        canonical={stateURL}
        openGraph={{
          title: metaTitle,
          type: 'website',
          url: stateURL,
        }}
      />
      <JsonLd {...{
        '@type': 'BreadcrumbList',
        itemListElement: [{
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': 'https://www.pga.com/play',
            name: 'Golf Courses',
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@id': stateURL,
            name: `${stateName}`,
          },
        }],
      }}
      />
      <Box py={[4, 4, 6]} bgcolor="white">
        <Container data-testid="state-container">
          <Box mb={[4, 4, 6]}>
            <Breadcrumbs component={Breadcrumbs}>
              <Link href="/play">Play</Link>
              <Box color="text.primary" component="span">{stateName}</Box>
            </Breadcrumbs>
          </Box>
          <Box mb={[4, 4, 6]}>
            <SearchCourse dark withTabs />
          </Box>
          <Box mb={[4, 4, 6]}>
            {isMobile ? <CtaCard ctaImage={CtaUrl} /> : <CtaBanner ctaImage={CtaUrl} />}
          </Box>
          <Box mb={[4, 4, 6]}>
            <Typography variant="h4">Golf Courses in {stateName}</Typography>
          </Box>
          <CoursesInStateQuery {...query} ssrData={ssrCitiesData} />
        </Container>
      </Box>
      <StatesQuery ssrData={ssrStatesData} />
    </div>
  ) : <Error statusCode={404} />
}

GolfCoursesPage.propTypes = {
  heroHeadline: PropTypes.string,
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  destinationsHeadline: PropTypes.string,
  featuredStory: PropTypes.shape({}),
  storiesCollection: PropTypes.shape({
    items: PropTypes.array,
  }),
  query: PropTypes.shape({
    state: PropTypes.string,
    city: PropTypes.string,
  }),
}

export default GolfCoursesPage
